import { IStyle } from '@fluentui/react';
import { CommonStyles } from '@h2oai/ui-kit';

export interface IArtifactListStyles {
  root?: IStyle;
  cardView?: IStyle;
  actions?: IStyle;
  actionButtons?: IStyle;
  downloadButton?: IStyle;
}

export interface IArtifactListClassNames {
  root: string;
  cardView: string;
  actions: string;
  actionButtons: string;
  downloadButton: string;
}

export const artifactListStylesDefault: Partial<IArtifactListStyles> = {
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
  actions: {
    ...CommonStyles.flexCenterVertically,
    width: '100%',
    '.Link-text': {
      position: 'relative',
    },
    '.download-loader': {
      display: 'none',
      position: 'absolute',
      height: '100%',
      width: '100%',
      left: '-5px',
      top: '0px',
    },
    '.download-loading': {
      '.download-loader': {
        display: 'block',
      },
    },
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },
};
